import React, { Component } from 'react'
import { withNamespaces } from 'react-i18next';
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";

//Miscellaneous
import { Icon } from '@iconify/react';
import { Fade } from "react-awesome-reveal";
// import { keyframes } from "@emotion/react";

//Components
import Skeleton from 'react-loading-skeleton';
import Button from '../../components/Button/Button';
import DateScroller from '../../components/MobileAssets/DateScroller/DateScroller';

class MobilePersonalFinance extends Component {
  constructor(props) {
    super(props);
    this.state =
    {
      // filterShow: '',
    };
  }

  componentDidMount() { }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  }

  render() {
    const { t } = this.props;
    const resetIcon = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));

    return (
      <Auxiliary>
        <DateScroller
          onChangeDateHandler={this.props.onChangeDateHandler}
          toggleShowDateSelect={this.props.toggleShowDateSelect}
          {...this.state}
          {...this.props}
        />
        <section className="pf-m-dashboard pf-category">
          <div className={`filters-m-col ${this.props.filterShow ? 'show' : ''}`}>
            <div className="filters-m-panel">
              <div className="filter-m-tp-col">
                <div className="filter-m-cat">
                  <label className="filter-m-label">{t('financial-report.stat-time')}:</label>
                  <button className={`btn btn-m-filter date ${this.props.filterShow === 'date' && 'active'}`} type="button" onClick={this.props.showDateHandler}>
                    <p>
                      {this.props.start_date}
                      <br />
                      {this.props.end_date}
                    </p>
                    <Icon icon="uil:angle-down" />
                  </button>
                </div>
                <div className="filter-m-cat">
                  <Button
                    typeButton="button"
                    classValue="btn btn-gradient-blue"
                    idValue="search"
                    buttonName={t("global.check")}
                    clicked={() => {
                      this.props.searchHandler();
                      this.setState({ filterShow: "" });
                    }}
                    disabled={this.props.disableSearchButton}
                  />
                  <button className="reset-btn" onClick={() => { this.props.onResetHandler(); this.setState({ filterShow: '' }); }}>
                    <img className={`${this.state.spin ? "spin" : ""} `} src={resetIcon["rotate-icon.svg"]} alt="reset" />
                  </button>
                </div>
              </div>
              <div className="filter-m-btm-col">
                <div className={`filters-m-date-group ${this.props.filterShow === 'date' ? 'd-block' : 'd-none'}`}>
                  <div className="filter-m-date">
                    <label className="filter-m-label">{t("history.start-date")}:</label>
                    <button className="btn btn-m-filter-date" type="button" onClick={(e) => this.props.toggleShowDateSelect(e, 'startDate')}>
                      <p>{this.props.start_date}</p>
                      <Icon icon="uil:angle-right" />
                    </button>
                  </div>
                  <div className="filter-m-date">
                    <label className="filter-m-label">{t("history.end-date")}:</label>
                    <button className="btn btn-m-filter-date" type="button" onClick={(e) => this.props.toggleShowDateSelect(e, 'endDate')}>
                      <p>{this.props.end_date}</p>
                      <Icon icon="uil:angle-right" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="overlay" onClick={this.props.offDateHandler} />
          <div className="pd-m-card-col">
          <Fade duration={1000} triggerOnce>
            <div className='row'>
              {this.props.loading ? <Skeleton count={2} style={{ marginBottom: ".5rem" }} height={180} /> : this.props.filterCategories &&
                this.props.filterCategories.map((item, index) => (
                  <div className="col-4" key={index}>
                    <div className="border-frame">
                      <p>{item.label}</p>
                      <h5>{item.amount}</h5>
                    </div>
                  </div>
                ))
              }
          </div>
          </Fade>
          </div>
        </section>
      </Auxiliary>
    )
  }
}

export default withNamespaces('translation')(MobilePersonalFinance);

